import { useSelector } from '@/stores/hooks'
import { isMobile, isReallyMobile } from '@/stores/meta'

export function useMobile(): boolean {
	return useSelector(isMobile)
}

export function useReallyMobile(): boolean {
	return useSelector(isReallyMobile)
}
